import axios from "axios";
import { server } from "../../server";

// Buyer: Submit offer
export const submitOffer = (offerData) => async (dispatch) => {
  try {
    dispatch({ type: "submitOfferRequest" });
    const { data } = await axios.post(`${server}/offer/submit-offer`, offerData, {
      withCredentials: true,
    });
    dispatch({ type: "submitOfferSuccess", payload: data.offer });
  } catch (error) {
    dispatch({ type: "submitOfferFailed", payload: error.response?.data?.message });
  }
};

// Buyer: Get my offers
export const getMyOffers = () => async (dispatch) => {
  try {
    dispatch({ type: "getMyOffersRequest" });
    const { data } = await axios.get(`${server}/offer/my-offers`, { withCredentials: true });
    dispatch({ type: "getMyOffersSuccess", payload: data.offers });
  } catch (error) {
    dispatch({ type: "getMyOffersFailed", payload: error.response?.data?.message });
  }
};

// Buyer: Cancel offer
export const cancelOffer = (offerId) => async (dispatch) => {
  try {
    dispatch({ type: "cancelOfferRequest" });
    const { data } = await axios.put(`${server}/offer/cancel-offer/${offerId}`, {}, {
      withCredentials: true,
    });
    dispatch({ type: "cancelOfferSuccess", payload: { id: offerId, message: data.message } });
  } catch (error) {
    dispatch({ type: "cancelOfferFailed", payload: error.response?.data?.message });
  }
};

// Admin: Get all offers
export const getAdminOffers = (status, page = 1) => async (dispatch) => {
  try {
    dispatch({ type: "getAdminOffersRequest" });
    let url = `${server}/offer/admin-all-offers?page=${page}`;
    if (status) url += `&status=${status}`;
    const { data } = await axios.get(url, { withCredentials: true });
    dispatch({ type: "getAdminOffersSuccess", payload: data });
  } catch (error) {
    dispatch({ type: "getAdminOffersFailed", payload: error.response?.data?.message });
  }
};

// Admin: Review offer
export const adminReviewOffer = (offerId, action, adminNotes) => async (dispatch) => {
  try {
    dispatch({ type: "adminReviewOfferRequest" });
    const { data } = await axios.put(
      `${server}/offer/admin-review-offer/${offerId}`,
      { action, adminNotes },
      { withCredentials: true }
    );
    dispatch({ type: "adminReviewOfferSuccess", payload: data.offer });
  } catch (error) {
    dispatch({ type: "adminReviewOfferFailed", payload: error.response?.data?.message });
  }
};

// Vendor: Get vendor offers
export const getVendorOffers = () => async (dispatch) => {
  try {
    dispatch({ type: "getVendorOffersRequest" });
    const { data } = await axios.get(`${server}/offer/vendor-offers`, { withCredentials: true });
    dispatch({ type: "getVendorOffersSuccess", payload: data.offers });
  } catch (error) {
    dispatch({ type: "getVendorOffersFailed", payload: error.response?.data?.message });
  }
};

// Vendor: Respond to offer
export const vendorRespondOffer = (offerId, response, vendorNotes) => async (dispatch) => {
  try {
    dispatch({ type: "vendorRespondOfferRequest" });
    const { data } = await axios.put(
      `${server}/offer/vendor-respond-offer/${offerId}`,
      { response, vendorNotes },
      { withCredentials: true }
    );
    dispatch({ type: "vendorRespondOfferSuccess", payload: data.offer });
  } catch (error) {
    dispatch({ type: "vendorRespondOfferFailed", payload: error.response?.data?.message });
  }
};
